/**
 * useProductFeatures — SaaSBOXX-controlled feature flags for LabBOXX.
 * Today: expose_local_user_management (default False).
 */
import { useEffect, useState } from 'react';

const PRODUCT_SLUG = 'labboxx';
const CACHE_KEY = 'app_switcher_cache_v1';

export interface ProductFeatures { exposeLocalUserManagement: boolean }
const DEFAULT_FEATURES: ProductFeatures = { exposeLocalUserManagement: false };

function readFromCache(slug: string): ProductFeatures | null {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    const tile = (data?.body?.apps || []).find((a: any) => a?.slug === slug);
    if (!tile) return null;
    return { exposeLocalUserManagement: tile.expose_local_user_management === true };
  } catch { return null; }
}
function readAuthToken(): string | null {
  for (const k of ['access_token', 'token', 'authToken']) {
    const v = localStorage.getItem(k);
    if (v) return v;
  }
  return null;
}

export function useProductFeatures(slug: string = PRODUCT_SLUG): ProductFeatures {
  const [features, setFeatures] = useState<ProductFeatures>(() => readFromCache(slug) || DEFAULT_FEATURES);
  useEffect(() => {
    const cached = readFromCache(slug);
    if (cached) { setFeatures(cached); return; }
    const token = readAuthToken();
    if (!token) return;
    let cancelled = false;
    fetch('/api/v1/auth/me/apps/', { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled || !data) return;
        const tile = (data.apps || []).find((a: any) => a?.slug === slug);
        if (tile) setFeatures({ exposeLocalUserManagement: tile.expose_local_user_management === true });
      })
      .catch(() => { /* keep defaults */ });
    return () => { cancelled = true; };
  }, [slug]);
  return features;
}
